import React, { KeyboardEvent } from 'react';

import Board from '../models/board';
import Tile from './Tile';

interface AppState {
  board: Board;
  isVictory: boolean;
}

class App extends React.Component<{}, AppState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      board: new Board(),
      isVictory: true
    };
  }

  handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    const board = this.state.board;

    if (event.key === "ArrowDown") {
      board.down();
    } else if (event.key === "ArrowLeft") {
      board.left();
    } else if (event.key === "ArrowRight") {
      board.right();
    } else if (event.key === "ArrowUp") {
      board.up();
    } else if (event.key === "R" || event.key === "r") {
      board.shuffle();
    } else {
      return;
    }

    const isVictory = board.isVictory();
    this.setState({ board, isVictory });
  };

  render() {
    return <div className="container" onKeyDown={this.handleKeyDown} tabIndex={0}>
      {this.state.board.getTiles().map((row, index) =>
        <div key={index} className="row">
          {row.map(col => <Tile key={col} num={col} />)}
        </div>)}
      {this.state.isVictory && <div className="row">teh win</div>}
    </div>;
  }
}

export default App;